import { all, call, put, takeEvery } from "redux-saga/effects";

import {
  getComplaint,
  getComplaintsTotalCount
  // updateComplaint
} from "../../Services/database";
import {
  getFileUrl
  //  uploadCompliantProof
} from "../../Services/storage";
import { isValidArray, isValidObject } from "../../Services/validators";
import { setErrorStatus, setSuccessStatus } from "../status/action";
import store from "../store";
import { createComplaint, updateComplaint } from "../../Services/api";
import { setSelectedComplaint } from "./action";

export const actionTypes = {
  SET_COMPLAINTS_DATA: "SET_COMPLAINTS_DATA",
  SET_SELECTED_COMPLAINT: "SET_SELECTED_COMPLAINT",
  UPDATE_COMPLAINTS_DATA: "UPDATE_COMPLAINTS_DATA",
  CREATE_COMPLAINTS: "CREATE_COMPLAINTS",
  FETCH_COMPLAINTS_ASSETS: "FETCH_COMPLAINTS_ASSETS",
  FIX_COMPLAINTS: "FIX_COMPLAINTS",
  COMPLAINT_TAKEOVER: "COMPLAINT_TAKEOVER",
  SET_COMPLAINTS_FILTER: "SET_COMPLAINTS_FILTER",
  SET_COMPLAINTS_SEARCH_KEY: "SET_COMPLAINTS_SEARCH_KEY",
  SET_COMPLAINTS_SORT: "SET_COMPLAINTS_SORT"
};

function* setSelectedComplaintWorker(action) {
  try {
    yield setComplaintsLoading(true);
    if (typeof action.payload.complaintId !== "string") {
      yield put({
        type: "PUT_SELECTED_COMPLAINT",
        payload: { data: null }
      });
      yield setComplaintsLoading(false);
      return;
    }

    const complaintsData = store.getState().complaints.data;
    let selectedComplaint = complaintsData?.[action.payload.complaintId];

    if (!isValidObject(selectedComplaint)) {
      selectedComplaint = yield getComplaint(action.payload.complaintId);
      if (!isValidObject(selectedComplaint)) {
        setErrorStatus({
          code: "custom",
          message: "Complaint resolved or not found"
        });
        if (action.payload.navigate) {
          action.payload.navigate("/complaints");
        }
        yield setComplaintsLoading(false);
        return;
      }
    }

    yield put({
      type: "PUT_SELECTED_COMPLAINT",
      payload: { data: selectedComplaint }
    });

    yield setComplaintsLoading(false);
  } catch (error) {
    yield setComplaintsLoading(false);
    if (
      error?.code === "permission-denied" ||
      error?.message?.includes("Missing or insufficient permissions")
    ) {
      yield setErrorStatus({
        code: "custom",
        message: "No permission to view this complaint."
      });

      if (action.payload.navigate) {
        yield action.payload.navigate("/complaints");
      }
    } else {
      setErrorStatus(error, "setSelectedComplaintWorker");
    }
  }
}

function* setComplaintsWorker(action) {
  try {
    yield setComplaintsLoading(true);
    const phoneNumber = store.getState().auth.data.phoneNumber;

    const count = yield getComplaintsTotalCount({
      filters: action.payload.filters,
      phoneNumber: phoneNumber
    });
    yield put({
      type: "SET_COMPLAINTS",
      payload: {
        data: action.payload.complaints
      }
    });
    yield put({
      type: "SET_COMPLAINTS_COUNT",
      payload: {
        data: count
      }
    });
    const selectedComplaintId =
      store.getState().complaints?.selectedComplaint?.documentId;
    if (typeof selectedComplaintId === "string") {
      yield setSelectedComplaint(selectedComplaintId, action.payload.navigate);
    }
    yield setComplaintsLoading(false);
  } catch (error) {
    yield setComplaintsLoading(false);
    setErrorStatus(error, "setComplaintsWorker");
  }
}

function* fetchSelectedComplaintsAssetsWorker() {
  try {
    yield setComplaintsLoading(true);
    const selectedComplaint = store.getState()?.complaints?.selectedComplaint;
    if (!isValidObject(selectedComplaint)) {
      return;
    }

    const updatedComplaint = { ...selectedComplaint };
    let rootProofUpdated = false;
    let updatesChanged = false;

    if (isValidArray(updatedComplaint.assets) && !updatedComplaint.proof) {
      const fileResults = yield all(
        updatedComplaint.assets.map((asset) => call(getFileUrl, asset))
      );

      const images = [];
      let proof = {};

      for (const file of fileResults) {
        if (file.type === "image") images.push(file.url);
        else if (file.type === "audio") proof.audio = file.url;
      }

      updatedComplaint.proof = {
        ...proof,
        ...(images.length ? { images } : {})
      };

      rootProofUpdated = true;
    }

    const updates = selectedComplaint.latestUpdate || [];
    const newUpdates = yield all(
      updates.map(function* (update) {
        const proof = update.proof || [];
        const assetCount =
          (update.assets?.images?.length || 0) + (update.assets?.audio ? 1 : 0);

        if (proof.length === assetCount) {
          return update;
        }

        const fileResults = yield all(proof.map((p) => call(getFileUrl, p)));

        const images = [];
        let assets = {};

        for (const file of fileResults) {
          if (file.type === "image") {
            images.push(file.url);
          } else if (file.type === "audio") {
            assets.audio = file.url;
          }
        }

        updatesChanged = true;

        return {
          ...update,
          assets: {
            ...assets,
            ...(images.length ? { images } : {})
          }
        };
      })
    );

    if (updatesChanged) {
      updatedComplaint.latestUpdate = newUpdates;
    }

    if (rootProofUpdated || updatesChanged) {
      yield put({
        type: "PUT_SELECTED_COMPLAINT",
        payload: { data: updatedComplaint }
      });
    }

    yield setComplaintsLoading(false);
  } catch (error) {
    yield setComplaintsLoading(false);

    setErrorStatus(error, "fetchComplaintsAssetsWorker");
  }
}

// function* fixComplaintsWorker(action) {
//   try {
//     yield setComplaintsLoading(true);
//     console.log("action:", action);
//     let imageFileUrls = [];
//     let audioFileUrl = [];

//     if (isValidArray(action.payload.proof?.image)) {
//       for (let index = 0; index < action.payload.proof.image.length; index++) {
//         yield uploadCompliantProof(
//           action.payload.proof.image[index],
//           action.payload.complaintId,
//           action.payload.locationId
//         );

//         imageFileUrls.push(
//           `${process.env.REACT_APP_DEFAULT_BUCKET}/${action.payload.locationId}/complaints/${action.payload.complaintId}/closure/${action.payload.proof.image?.[index]?.name}`
//         );
//       }
//     }

//     if (action.payload.proof?.audio) {
//       yield uploadCompliantProof(
//         action.payload.proof.audio,
//         action.payload.complaintId,
//         action.payload.locationId
//       );
//       audioFileUrl.push(
//         `${process.env.REACT_APP_DEFAULT_BUCKET}/${action.payload.locationId}/complaints/${action.payload.complaintId}/closure/${action.payload.proof.audio?.name}`
//       );
//     }
//     const proof = [...imageFileUrls, ...audioFileUrl];

//     const profileData = store.getState().profile.data;

//     const currentTime = +new Date();

//     yield updateComplaint(action.payload.complaintId, {
//       status: { currentStatus: "UNDER REVIEW", updatedAt: currentTime },
//       closure: {
//         resolvedAt: currentTime,
//         resolvedBy: profileData.employeeId,
//         ...(isValidArray(proof) ? { proof: proof } : {}),
//         ...(action.payload.remarks && action.payload.remarks.length > 0
//           ? { remarks: action.payload.remarks }
//           : {})
//       },
//       latestUpdate: {
//         ...(isValidArray(proof) ? { proof: proof } : {}),
//         description:
//           action.payload.remarks && action.payload.remarks.length > 0
//             ? action.payload.remarks
//             : "Status changed from OPEN to UNDER REVIEW",
//         previousStatus: "OPEN",
//         currentStatus: "UNDER REVIEW",
//         updatedBy: {
//           employeeId: profileData.employeeId,
//           employeeName: profileData.name,
//           phoneNumber: profileData.phoneNumber
//         },
//         updatedAt: currentTime
//       }
//     });

//     setSuccessStatus("Submitted successfully");
//     yield put({
//       type: "PUT_SELECTED_COMPLAINT",
//       payload: { data: null }
//     });
//     if (action.payload.navigate) {
//       action.payload.navigate("/complaints");
//     }

//     yield setComplaintsLoading(false);
//   } catch (error) {
//     setErrorStatus(error, "fixComplaintsWorker");
//     yield setComplaintsLoading(false);
//   }
// }

// function* complaintTakeoverWorker(action) {
//   try {
//     yield setComplaintsLoading(true);

//     const currentTime = +new Date();

//     yield updateComplaint(action.payload.complaintId, {
//       takenOverBy: {
//         ...action.payload.employeeData,
//         takenOverAt: currentTime
//       },
//       latestUpdate: {
//         description: `Taken over by ${action.payload.employeeData.phoneNumber} ${action.payload.employeeData.employeeName}`,
//         updatedAt: currentTime,
//         updatedBy: action.payload.employeeData
//       }
//     });

//     const complaintData = store.getState().complaints.data;
//     yield put({
//       type: "SET_COMPLAINTS",
//       payload: {
//         data: {
//           ...complaintData,
//           [action.payload.complaintId]: {
//             ...complaintData?.[action.payload.complaintId],
//             takenOverBy: action.payload.employeeData
//           }
//         }
//       }
//     });

//     const updatedComplaint = yield getComplaint(action.payload.complaintId);
//     yield put({
//       type: "PUT_SELECTED_COMPLAINT",
//       payload: { data: updatedComplaint }
//     });

//     setSuccessStatus("Complaint taken over successfully");

//     yield setComplaintsLoading(false);
//   } catch (error) {
//     console.error("complaintTakeoverWorker", error);
//     setErrorStatus(error, "complaintTakeoverWorker");
//     yield setComplaintsLoading(false);
//   }
// }

// function* updateComplaintsWorker(action) {
//   try {
//     yield setComplaintsLoading(true);
//     let imageFileUrls = [];
//     let audioFileUrl = [];

//     if (isValidArray(action.payload.proof.image)) {
//       for (let index = 0; index < action.payload.proof.image.length; index++) {
//         yield uploadCompliantProof(
//           action.payload.proof.image[index],
//           action.payload.complaintId,
//           action.payload.locationId
//         );
//         imageFileUrls.push(
//           `${process.env.REACT_APP_DEFAULT_BUCKET}/${action.payload.locationId}/complaints/${action.payload.complaintId}/closure/${action.payload.proof.image?.[index]?.name}`
//         );
//       }
//     }

//     if (action.payload.proof.audio) {
//       yield uploadCompliantProof(
//         action.payload.proof.audio,
//         action.payload.complaintId,
//         action.payload.locationId
//       );
//       audioFileUrl.push(
//         `${process.env.REACT_APP_DEFAULT_BUCKET}/${action.payload.locationId}/complaints/${action.payload.complaintId}/closure/${action.payload.proof.audio?.name}`
//       );
//     }
//     const employeeData = store.getState().profile.data;

//     const proof = [...imageFileUrls, ...audioFileUrl];

//     yield updateComplaint(action.payload.complaintId, {
//       latestUpdate: {
//         ...(isValidArray(proof) ? { proof: proof } : {}),
//         description: action.payload.remarks,
//         updatedBy: {
//           employeeId: employeeData.employeeId,
//           employeeName: employeeData.name,
//           phoneNumber: employeeData.phoneNumber
//         },
//         updatedAt: +new Date()
//       }
//     });

//     const updatedComplaint = yield getComplaint(action.payload.complaintId);
//     yield put({
//       type: "PUT_SELECTED_COMPLAINT",
//       payload: { data: updatedComplaint }
//     });

//     setSuccessStatus("Update added successfully");

//     yield setComplaintsLoading(false);
//   } catch (error) {
//     console.error("updateComplaintsWorker", error);
//     setErrorStatus(error, "updateComplaintsWorker");
//     yield setComplaintsLoading(false);
//   }
// }

function* fixComplaintsWorker(action) {
  try {
    yield setComplaintsLoading(true);

    const { complaintId, locationId, proof, remarks } = action.payload;
    const profileData = store.getState().profile.data;
    const authData = store.getState().auth.data;

    let formDataPayload = new FormData();

    if (isValidArray(proof?.image)) {
      for (let i = 0; i < proof.image.length; i++) {
        if (proof.image[i]) {
          formDataPayload.append("files", proof.image[i]);
        }
      }
    }

    if (proof?.audio) {
      formDataPayload.append("files", proof.audio);
    }

    const currentTime = +new Date();

    formDataPayload.append("complaintId", complaintId);
    formDataPayload.append("locationId", locationId);

    formDataPayload.append(
      "status",
      JSON.stringify({
        currentStatus: "UNDER REVIEW",
        updatedAt: currentTime
      })
    );

    formDataPayload.append(
      "closure",
      JSON.stringify({
        resolvedAt: currentTime,
        resolvedBy: profileData.employeeId,
        ...(remarks && remarks.length > 0 ? { remarks } : {})
      })
    );

    formDataPayload.append(
      "latestUpdate",
      JSON.stringify({
        description:
          remarks && remarks.length > 0
            ? remarks
            : "Status changed from OPEN to UNDER REVIEW",
        previousStatus: "OPEN",
        currentStatus: "UNDER REVIEW",
        updatedBy: {
          employeeId: profileData.employeeId,
          employeeName: profileData.name,
          phoneNumber: profileData.phoneNumber
        },
        updatedAt: currentTime
      })
    );

    yield updateComplaint(formDataPayload, authData.accessToken);

    yield setSuccessStatus("Submitted successfully");

    yield put({
      type: "PUT_SELECTED_COMPLAINT",
      payload: { data: null }
    });

    if (action.payload.navigate) {
      action.payload.navigate("/complaints");
    }

    yield setComplaintsLoading(false);
  } catch (error) {
    setErrorStatus(error, "fixComplaintsWorker");
    yield setComplaintsLoading(false);
  }
}

function* complaintTakeoverWorker(action) {
  try {
    yield setComplaintsLoading(true);

    const currentTime = +new Date();
    const { complaintId, employeeData } = action.payload;
    const authData = store.getState().auth.data;

    let formDataPayload = new FormData();

    formDataPayload.append("complaintId", complaintId);

    formDataPayload.append(
      "takenOverBy",
      JSON.stringify({
        ...employeeData,
        takenOverAt: currentTime
      })
    );

    formDataPayload.append(
      "latestUpdate",
      JSON.stringify({
        description: `Taken over by ${employeeData.phoneNumber} ${employeeData.employeeName}`,
        updatedAt: currentTime,
        updatedBy: employeeData
      })
    );

    yield updateComplaint(formDataPayload, authData.accessToken);

    const complaintData = store.getState().complaints.data;
    yield put({
      type: "SET_COMPLAINTS",
      payload: {
        data: {
          ...complaintData,
          [complaintId]: {
            ...complaintData?.[complaintId],
            takenOverBy: { ...employeeData, takenOverAt: currentTime }
          }
        }
      }
    });

    const currentSelectedComplaint = store.getState().complaints.selectedComplaint;
    yield put({
      type: "PUT_SELECTED_COMPLAINT",
      payload: {
        data: {
          ...currentSelectedComplaint,
          takenOverBy: { ...employeeData, takenOverAt: currentTime }
        }
      }
    });

    const updatedComplaint = yield getComplaint(complaintId);
    if (isValidObject(updatedComplaint)) {
      yield put({
        type: "PUT_SELECTED_COMPLAINT",
        payload: { data: updatedComplaint }
      });
    }

    setSuccessStatus("Complaint taken over successfully");
    yield setComplaintsLoading(false);
  } catch (error) {
    console.error("complaintTakeoverWorker", error);
    setErrorStatus(error, "complaintTakeoverWorker");
    yield setComplaintsLoading(false);
  }
}

function* updateComplaintsWorker(action) {
  try {
    yield setComplaintsLoading(true);

    const { complaintId, locationId, proof, remarks } = action.payload;
    const employeeData = store.getState().profile.data;
    const currentTime = +new Date();
    const authData = store.getState().auth.data;

    let formDataPayload = new FormData();

    formDataPayload.append("complaintId", complaintId);
    formDataPayload.append("locationId", locationId);

    if (isValidArray(proof?.image)) {
      for (let i = 0; i < proof.image.length; i++) {
        if (proof.image[i]) {
          formDataPayload.append("files", proof.image[i]);
        }
      }
    }

    if (proof?.audio) {
      formDataPayload.append("files", proof.audio);
    }

    formDataPayload.append(
      "latestUpdate",
      JSON.stringify({
        description: remarks,
        updatedBy: {
          employeeId: employeeData.employeeId,
          employeeName: employeeData.name,
          phoneNumber: employeeData.phoneNumber
        },
        updatedAt: currentTime
      })
    );

    yield updateComplaint(formDataPayload, authData.accessToken);

    const updatedComplaint = yield getComplaint(complaintId);
    yield put({
      type: "PUT_SELECTED_COMPLAINT",
      payload: { data: updatedComplaint }
    });

    setSuccessStatus("Update added successfully");
    yield setComplaintsLoading(false);
  } catch (error) {
    console.error("updateComplaintsWorker", error);
    setErrorStatus(error, "updateComplaintsWorker");
    yield setComplaintsLoading(false);
  }
}

function* setComplaintsFilterWorker(action) {
  try {
    yield put({
      type: "PUT_COMPLAINTS_FILTER",
      payload: { data: action.payload.data }
    });
  } catch (error) {
    console.error("setComplaintsFilterWorker", error);
    setErrorStatus(error);
  }
}

function* setComplaintsSearchKeyWorker(action) {
  try {
    yield put({
      type: "PUT_COMPLAINTS_SEARCH_KEY",
      payload: { data: action.payload.data }
    });
  } catch (error) {
    setErrorStatus(error);
  }
}

function* setComplaintsSortWorker(action) {
  try {
    yield put({
      type: "PUT_COMPLAINTS_SORT",
      payload: { data: action.payload.data }
    });
  } catch (error) {
    setErrorStatus(error);
  }
}

function* createComplaintsWorker(action) {
  try {
    yield setComplaintsLoading(true);

    const { selectedLocation, data, files } = action.payload.data;

    if (!selectedLocation) {
      yield setComplaintsLoading(false);
      return setErrorStatus({
        code: "custom",
        message: "select a valid location"
      });
    }

    const formData = data;
    const authData = store.getState().auth.data;
    const profileData = store.getState().profile.data;

    if (!isValidArray(formData?.issue)) {
      yield setComplaintsLoading(false);
      return setErrorStatus({
        code: "error",
        message: "Select a valid issue"
      });
    }

    for (let i = 0; i < formData?.issue.length; i++) {
      let formDataPayload = new FormData();

      if (isValidArray(files)) {
        for (let j = 0; j < files.length; j++) {
          if (files[j]) {
            formDataPayload.append("files", files[j]);
          }
        }
      }

      formDataPayload.append("locationId", selectedLocation);
      formDataPayload.append("category", formData?.issue?.[i]);
      formDataPayload.append(
        "issuedBy",
        JSON.stringify({
          issuedAt: +new Date(),
          type: "internal",
          userDetails: {
            employeeId: profileData?.employeeId,
            name: profileData?.name,
            phoneNumber: profileData?.phoneNumber
          }
        })
      );
      formDataPayload.append(
        "status",
        JSON.stringify({
          currentStatus: "OPEN",
          updatedAt: +new Date()
        })
      );

      yield createComplaint(formDataPayload, authData.accessToken);
    }

    yield setSuccessStatus("Created Successfully");
    yield setComplaintsLoading(false);
  } catch (error) {
    yield setComplaintsLoading(false);
    yield setErrorStatus(error);
  }
}

export default function* complaintWatcher() {
  yield all([
    takeEvery("SET_COMPLAINTS_DATA", setComplaintsWorker),
    takeEvery("SET_SELECTED_COMPLAINT", setSelectedComplaintWorker),
    takeEvery("CREATE_COMPLAINTS", createComplaintsWorker),
    takeEvery("FIX_COMPLAINTS", fixComplaintsWorker),
    takeEvery("UPDATE_COMPLAINTS_DATA", updateComplaintsWorker),
    takeEvery("FETCH_COMPLAINTS_ASSETS", fetchSelectedComplaintsAssetsWorker),
    takeEvery("COMPLAINT_TAKEOVER", complaintTakeoverWorker),
    takeEvery("SET_COMPLAINTS_FILTER", setComplaintsFilterWorker),
    takeEvery("SET_COMPLAINTS_SEARCH_KEY", setComplaintsSearchKeyWorker),
    takeEvery("SET_COMPLAINTS_SORT", setComplaintsSortWorker)
  ]);
}

function* setComplaintsLoading(bool) {
  yield put({
    type: "SET_COMPLAINTS_LOADING",
    payload: {
      loading: bool
    }
  });
}
